'use client';

import { sanitizeSearchTerm } from '@lichtblick/cms/helpers/sanitize-search-term';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import { Textfield } from '@lichtblick/photon/molecules/legacy-textfield/textfield';
import { Breakpoints } from '@lichtblick/theme/constants/breakpoints';
import { useRouter } from 'next/navigation';
import { type FC, useEffect, useRef } from 'react';
import { useFormStatus } from 'react-dom';
import styles from './search.module.scss';

const SubmitButton = () => {
  const { pending } = useFormStatus();

  return (
    <BoxCTA as="button" disabled={pending} leftSlot={<MagnifyingGlassXs />} size="medium" type="submit">
      Suchen
    </BoxCTA>
  );
};

export const SearchForm: FC<{ defaultValue?: string }> = ({ defaultValue }) => {
  const router = useRouter();
  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (window.matchMedia(`(max-width: ${Breakpoints.Tablet - 1}px)`).matches) {
      return;
    }

    searchInputRef.current?.focus();
    searchInputRef.current?.setSelectionRange(-1, -1);
  }, []);

  return (
    <form
      action={(formData) => {
        const searchTerm = formData.get('search') as string;
        router.push(`/suche/${encodeURIComponent(sanitizeSearchTerm(searchTerm))}/`);
      }}
      className={styles.form}
    >
      <Textfield
        aria-label="Suche"
        autoComplete="off"
        className={styles['search-input']}
        defaultValue={defaultValue}
        maxLength={80}
        minLength={3}
        name="search"
        onInvalid={(e) => {
          e.preventDefault();
        }}
        placeholder="Suchbegriff"
        ref={searchInputRef}
        type="search"
      />
      <SubmitButton />
    </form>
  );
};
